import { render } from "./ProductoCreate.vue?vue&type=template&id=0894ad81&scoped=true"
import script from "./ProductoCreate.vue?vue&type=script&lang=js"
export * from "./ProductoCreate.vue?vue&type=script&lang=js"

import "./ProductoCreate.vue?vue&type=style&index=0&id=0894ad81&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0894ad81"]])

export default __exports__